import { useMutation } from '@tanstack/react-query';
import { fetchDiAccountsByBac, fetchDiOrderItemsByReferenceId, fetchDiOrderItemsLiveByBac } from './diApi';

export const createDiHooks = () => {
    const useDiAccountsByBac = () =>
        useMutation({
            mutationFn: (bacs) => fetchDiAccountsByBac(bacs),
        });

    const useDiOrderItemsByReferenceId = () =>
        useMutation({
            mutationFn: (referenceIds) => fetchDiOrderItemsByReferenceId(referenceIds),
        });

    const useDiOrderItemsLiveByBac = () =>
        useMutation({
            mutationFn: (bacs) => fetchDiOrderItemsLiveByBac(bacs),
        });

    return {
        useDiAccountsByBac,
        useDiOrderItemsByReferenceId,
        useDiOrderItemsLiveByBac,
    };
};
